'use client';

import {
  CustomersPartners,
  EventSupplyNetwork,
  Footer,
  HeroSection,
  HumanAICollaboration,
  MissionSection,
  OurPromise,
  ProvenAtScale,
  VerticalAIEngine,
  WhyHaflaWorks
} from 'components/atomic/atoms';
import { HeaderOrganism } from 'components/atomic/organism';

const AboutUs = () => (
  <div className='text-nero'>
    <HeaderOrganism heading='About Us' />
    <HeroSection />
    <MissionSection />
    <VerticalAIEngine />
    <HumanAICollaboration />
    <EventSupplyNetwork />
    <ProvenAtScale />
    <WhyHaflaWorks />
    <CustomersPartners />
    <OurPromise />
    <Footer />
  </div>
);

export default AboutUs;
